export enum ContactedStatus {
  Answer = "answer",
  NoAnswer = "noanswer",
}
